import { activityGuardTimerAlert, activityGuardTimerTimeout } from 'Config';
import { useAppSelector } from 'Hooks';
import { useCallback, useEffect, useRef, useState } from 'react';
import { LogoutWarningAndNotificationModal } from './LogoutWarningAndNotificationModal';

const userDetectionEvents: string[] = [
  'mousemove',
  'keypress',
  'click',
  'keydown',
  'mousewheel',
  'mousedown',
  'touchstart',
  'touchmove',
  'focus',
  'DOMMouseScroll',
];

export const ActivityGuard: React.FC<any> = (props) => {
  const [timeoutSeconds, setTimeoutSeconds] = useState<number>(
    activityGuardTimerTimeout
  );
  const timeoutSecondsRef = useRef<number>(timeoutSeconds);
  const [showLogoutWarningModal, setShowLogoutWarningModal] =
    useState<boolean>(false);

  const { authenticatedUser } = useAppSelector(({ imposter }) => imposter);
  const isUser = authenticatedUser?.israeliId;

  const initActivityDetection = useCallback(() => {
    if (!isUser) return;

    const handleUserActivity = () =>
      timeoutSecondsRef.current > 0
        ? setTimeoutSeconds(activityGuardTimerTimeout)
        : undefined;

    userDetectionEvents.map((eventName: string) => {
      return window.addEventListener(eventName, handleUserActivity);
    });

    const intervalDetection = setInterval(() => {
      if (timeoutSecondsRef.current > 0)
        setTimeoutSeconds((prevTime) => prevTime - 1);
    }, 1000);

    return () => {
      if (!isUser) return;
      userDetectionEvents.map((eventName: string) => {
        return window.removeEventListener(eventName, handleUserActivity);
      });

      clearInterval(intervalDetection);
    };
  }, [isUser]);

  useEffect(() => {
    return initActivityDetection();
  }, [initActivityDetection]);

  useEffect(() => {
    timeoutSecondsRef.current = timeoutSeconds;
    if (timeoutSeconds === activityGuardTimerAlert)
      setShowLogoutWarningModal(true);
    if (timeoutSeconds <= 0) sessionStorage.clear();
  }, [timeoutSeconds]);

  return (
    <>
      {showLogoutWarningModal && (
        <LogoutWarningAndNotificationModal
          isWarning={timeoutSeconds > 0}
          closeModal={() => setShowLogoutWarningModal(false)}
        />
      )}
      {props.children}
    </>
  );
};
